/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Continue_WorkoutInputs */

const en_us2_plan_continue_workout = /** @type {(inputs: Plan_Continue_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue workout`)
};

const pt_br2_plan_continue_workout = /** @type {(inputs: Plan_Continue_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar treino`)
};

const es_419_plan_continue_workout = /** @type {(inputs: Plan_Continue_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar entrenamiento`)
};

const pt_pt2_plan_continue_workout = /** @type {(inputs: Plan_Continue_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar treino`)
};

const fr_fr2_plan_continue_workout = /** @type {(inputs: Plan_Continue_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer la séance`)
};

const de_de2_plan_continue_workout = /** @type {(inputs: Plan_Continue_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training fortsetzen`)
};

const it_it2_plan_continue_workout = /** @type {(inputs: Plan_Continue_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua allenamento`)
};

/**
* | output |
* | --- |
* | "Continue workout" |
*
* @param {Plan_Continue_WorkoutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_continue_workout = /** @type {((inputs?: Plan_Continue_WorkoutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Continue_WorkoutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_continue_workout(inputs)
	if (locale === "es-419") return es_419_plan_continue_workout(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_continue_workout(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_continue_workout(inputs)
	if (locale === "de-DE") return de_de2_plan_continue_workout(inputs)
	if (locale === "it-IT") return it_it2_plan_continue_workout(inputs)
	return en_us2_plan_continue_workout(inputs)
});
export { plan_continue_workout as "plan.continue_workout" }